import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import styles from './styles.module.scss'

const cx = classNames.bind(styles)
interface Props {
  name: string
  color: string
  field: Field
}

const Radio = ({ name, color, field }: Props) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.set(event.target.value)
  }
  const checked = color === field.value

  return (
    <label
      className={cx('color', {
        checked,
      })}
    >
      <input
        className={styles.input}
        name={name}
        value={color}
        type="radio"
        checked={checked}
        onChange={onChange}
      />
      <div
        style={{
          backgroundColor: `#${color}`,
        }}
        className={styles.colorItem}
      >
        {checked && (
          <div className={styles.icon}>
            <Icon.Medium icon="check" color="grey000White" />
          </div>
        )}
      </div>
    </label>
  )
}

export default observer(Radio)
